<template>
<div>
  <div class="wistia_embed wistia_async_iv3z8lcm5e">
    &nbsp;
  </div>

  <div
    id="serving_diverse_populations_choose"
    class="tbk-vid-embed"
  >
    <a
      id="kate_reuer_welton"
      class="embedded_video"
      href="#wistia_amkv0kjl90?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="brad_froslee"
      class="embedded_video"
      href="#wistia_nf2joxgtug?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
    <a
      id="irma_banales"
      class="embedded_video"
      href="#wistia_0jmuyff2rn?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
    <a
      id="mark_aune"
      class="embedded_video"
      href="#wistia_uaydgsfy97?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('iv3', 21, this.showSelect)

    this.tbk.loadCrossTime('amk', 243, this.showSelect)
    this.tbk.loadCrossTime('nf2', 62, this.showSelect)
    this.tbk.loadCrossTime('0jm', 128, this.showSelect)
    this.tbk.loadCrossTime('uay', 99, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        amk: this.tbk.autoPlay,
        nf2: this.tbk.autoPlay,
        '0jm': this.tbk.autoPlay,
        uay: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style lang="sass" scoped>
#serving_diverse_populations_choose
  display: none
  a
    text-decoration: none
#kate_reuer_welton
  position: absolute
  top: 0
  left: 0
  width: 50%
  height: 54%
#brad_froslee
  position: absolute
  top: 0
  left: 50%
  width: 50%
  height: 54%
#irma_banales
  position: absolute
  top: 54%
  left: 0
  width: 50%
  height: 46%
#mark_aune
  position: absolute
  top: 54%
  left: 50%
  width: 50%
  height: 46%
</style>

